import React from "react";

import HealthSection from "./HealthSection";
import TeamMembersHealth from "./TeamMembersHealth";

import teamHealthIcon from "../../assets/icons/team-health.svg";

import collaborationIcon from "../../assets/images/onboarding/collaboration.svg";
import communicationIcon from "../../assets/images/onboarding/communication.svg";
import engagementIcon from "../../assets/images/onboarding/engagement.svg";
import adaptabilityIcon from "../../assets/images/onboarding/adaptability.svg";

const getKPIs = (collaboration, communication, engagement, adaptability) => [
  {
    title: I18n.t("dashboard.team_health.adaptability.title"),
    score: adaptability?.score,
    indicator: adaptability?.indicator,
    message: adaptability?.message,
    icon: adaptabilityIcon,
    about: I18n.t("dashboard.team_health.adaptability.about")                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
  },
  {
    title: I18n.t("dashboard.team_health.collaboration.title"),
    score: collaboration?.score,
    indicator: collaboration?.indicator,
    message: collaboration?.message,
    icon: collaborationIcon,
    about: I18n.t("dashboard.team_health.collaboration.about")
  },
  {
    title: I18n.t("dashboard.team_health.communication.title"),
    score: communication?.score,
    indicator: communication?.indicator,
    message: communication?.message,
    icon: communicationIcon,
    about: I18n.t("dashboard.team_health.communication.about")
  },
  {
    title: I18n.t("dashboard.team_health.engagement.title"),
    score: engagement?.score,
    indicator: engagement?.indicator,
    message: engagement?.message,
    icon: engagementIcon,
    about: I18n.t("dashboard.team_health.engagement.about")
  }
];

const TeamHealth = (props) => {
  const {
    collaboration,
    communication,
    engagement,
    adaptability,
    showMemberDetails,
    membersHealths,
    ofuscate
  } = props;

  return (
    <div className="team-health-section">
      <HealthSection
        icon={teamHealthIcon}
        title={I18n.t("dashboard.team_health.title")}
        kpis={getKPIs(collaboration, communication, engagement, adaptability)}
        ofuscate={ofuscate}
      />
      {showMemberDetails && membersHealths ? (
        <TeamMembersHealth healths={membersHealths} />
      ) : null}
    </div>
  );
}

export default TeamHealth;
